
export default superclass => class extends superclass  {
    regions = [];
    densityCache = {};

    newRegion(x,y,radius=10) {
        let region = {
                x,
                y,
                radius,
                viscosity: 10 // 1-10
        };

        this.regions = [
            ... this.regions,
            region
        ];
        return region;
    }
   
    deleteDensity(region) {
        let index = this.regions.indexOf(region);
        if (index > -1) {
            this.regions.splice(index, 1);
            this.regions = [... this.regions];
        }
    }

    getViscosity(x,y) {
        let viscosities = 0;
        let key = x+','+y;
        if (this.densityCache[key]) {
            return this.densityCache[key];
        }
        // go through the regions
        for (let region of this.regions) {
            if (dist(x,y,region.x,region.y) <= region.radius) {
                viscosities += region.viscosity;
            }
        }
        let d = viscosities === 0 ? 1 : viscosities;
        this.densityCache[key] = d;
        return d;
    }

    expandRegion(region, factor) {
        this.cache = {};
        let index = this.regions.indexOf(region);
        this.regions[index] = {
            ... region,
            radius: region.radius * factor
        };
        this.regions = [... this.regions];
    }

    expandViscosity(region, factor) {
        this.cache = {};
        let index = this.regions.indexOf(region);
        this.regions[index] = {
            ... region,
            viscosity: region.viscosity * factor
        };
        this.regions = [... this.regions];
    }

    expandDensitySize(region, factor) {
        this.cache = {};
        region.radius = region.radius * factor;
        this.regions = [... this.regions];
        return region;
    }

    getDensityJson() {
        return this.regions;
    }

    fromDensityJson(json) {
        this.regions = json;
    }
}

const sqrt = Math.sqrt;
const sq = (x) => Math.pow(x, 2);
    const dist = (x1,y1,x2,y2) => sqrt(sq(x2-x1) + sq(y2 - y1));
    
